import { formatCents } from '@src/common';
import { getSaleItemDiscountValue } from '@src/common/checkout';
import { SaleItem as SaleItemType } from '@src/core/buyerApiClient';
import useTranslate from '@src/i18n/useTranslate';
import React from 'react';
import SaleItem from '../Summary/SaleSummary/SaleItem';
import {
  PackageDiscountValue,
  PackageOriginalPrice,
  PackagePriceInfo,
  PackagePrices,
  PackageTotalPrice,
} from './styles';

interface SaleItemComponentProps {
  item: SaleItemType;
  showPlaceholderImage?: boolean;
}

export const SalePackageItemDetail: React.FC<SaleItemComponentProps> = ({ item, showPlaceholderImage = false }) => {
  const { i18n } = useTranslate();
  const discountValue = getSaleItemDiscountValue(item);

  return (
    <SaleItem showPlaceholderImage={showPlaceholderImage} key={item.id} item={item}>
      <PackagePrices>
        <PackagePriceInfo>
          {i18n('cart_package_previous_price')}
          <PackageOriginalPrice>{formatCents(item.fullPriceCents)}</PackageOriginalPrice>
        </PackagePriceInfo>

        <PackagePriceInfo>
          {i18n('cart_package_discount')}
          <PackageDiscountValue>-{formatCents(discountValue)}</PackageDiscountValue>
        </PackagePriceInfo>

        <PackagePriceInfo>
          {i18n('cart_package_total')}
          <PackageTotalPrice>{formatCents(item.totalPriceCents)}</PackageTotalPrice>
        </PackagePriceInfo>
      </PackagePrices>
    </SaleItem>
  );
};

export default SalePackageItemDetail;
